import { render } from "./lhc-bet-confirm.vue?vue&type=template&id=0c4b53e1&scoped=true"
import script from "./lhc-bet-confirm.vue?vue&type=script&lang=js"
export * from "./lhc-bet-confirm.vue?vue&type=script&lang=js"

import "./lhc-bet-confirm.vue?vue&type=style&index=0&id=0c4b53e1&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lhc\\hk-lottery-lhc-ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4b53e1"]])

export default __exports__